// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dy","footer":"dz","subscriptionsList":"dA","disclaimer":"dB"};